import { render, staticRenderFns } from "./ResultManagement.vue?vue&type=template&id=7bf518e4"
import script from "./ResultManagement.vue?vue&type=script&lang=js"
export * from "./ResultManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports